// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__s1eht","vLegacy":"SelectSecondary_vLegacy__2n3QP","error":"SelectSecondary_error__27nW1","disabled":"SelectSecondary_disabled__3uYUG"};